<div class="fcp-table-row">
    <div class="fcp-table-row-input">
        <ng-container [ngSwitch]="state">
            <fcp-form-field
                class="fcp-table-row-input-form"
                width="fluid"
                [isInvalid]="inputControl.invalid"
                *ngSwitchCase="'active'"
            >
                <input fcpInput [formControl]="inputControl" (keypress)="maskValue(inputControl.value, $event)" />
                <span fcpFieldError>{{ getErrorMessage(inputControl) }} </span>
            </fcp-form-field>
            <p
                *ngSwitchDefault
                class="fcp-table-row-text"
                [ngClass]="{
                    strike: state === 'remove'
                }"
            >
                {{ value }}
            </p>
        </ng-container>
    </div>
    <ng-container [ngSwitch]="state">
        <div class="fcp-table-row-actions" *ngSwitchCase="'default'">
            <button fcp-transparent-button color="prominent" iconOnly="true" (click)="onEdit()">
                <fcp-icon [icon]="['fal', 'pencil-alt']" style="font-size: 16px"></fcp-icon>
            </button>
            <button fcp-transparent-button color="critical" iconOnly="true" (click)="onRemove()">
                <fcp-icon [icon]="['fal', 'trash-can']" style="font-size: 16px"></fcp-icon>
            </button>
        </div>
        <div class="fcp-table-row-actions" *ngSwitchCase="'active'">
            <button fcp-outlined-button color="prominent" size="small" (click)="onCancel()">Cancel</button>
            <button
                fcp-button
                color="prominent"
                size="small"
                [disabled]="inputControl.invalid || !hasValueChanged()"
                (click)="onAdd()"
            >
                Add
            </button>
        </div>
        <div class="fcp-table-row-actions" *ngSwitchCase="'remove'">
            <button fcp-transparent-button color="prominent" size="small" (click)="onUndo()">Undo</button>
        </div>
    </ng-container>
</div>
